import apis from "@/api";

// search conditions
export const conditions = [
  {
    type: "department",
    span: 8
  },
  {
    type: "fields",
    span: 8,
    label: "搜索查询",
    key: "queryName",
    placeholder: "输入单据名称或申请人"
  },
  {
    type: "project",
    span: 8
  },
  {
    type: "applyType",
    span: 8
  },
];

export const paymentColumns = [
  { title: "单据编号", key: "applyNumber", align: "center", minWidth: 150 },
  { title: "项目", key: "projectName", align: "center", minWidth: 150 },
  {
    title: "领款人",
    key: "receiveEmployeeName",
    align: "center",
    minWidth: 100
  },
  { title: "部门", key: "departmentName", align: "center", minWidth: 100 },
  { title: "金额", key: "money", align: "center", minWidth: 100 },
  {
    title: "开户行",
    key: "receiverBankName",
    align: "center",
    minWidth: 150
  },
  {
    title: "收款账号",
    key: "receiverBankNumber",
    align: "center",
    minWidth: 200
  },
  { title: "完成审批", key: "applyPassTime", align: "center", minWidth: 200 }
];

export const mergeLines = [
  { field: "applyId" },
  { field: "applyNumber", condition: "applyId" },
  { field: "applyTitle", condition: "applyId" }
];



export const projectEnumId = "10001";

export const initSearchParameter = {
  queryName: "",
  applyTypeEnumItemCode: "",
  departmentId: "",
  projectId: ""
};
export const paymentStatus = [
  "waitPay",
  "reconciled",
  "finished",
  "paymentFail"
];

export const paymentDescribe = {
  waitPay: {
    describeTitle:
      "支付管理可以根据团队账户的开户行，为您导出适合的批量支付模板。",
    describe:
      "若您认为支付信息存在明显风险，您可以在“待支付”阶段进行驳回，但需要注意的是，当您点击“确认并导出支付信息”后，Gobills系统会默认您已经开始线下支付流程，由于线下流程的复杂性，此操作将不可逆，请您谨慎操作。"
  },

  reconciled: {
    describeTitle:
      "如果您长时间没有收到某条付款记录的银行对账单，或因某些原因确定某条付款记录支付失败，您可以先将其设置为“支付失败”。被设置为“支付失败”的单据，待您确认无误后，可以重新导出付款信息进行支付。",
    describe:
      "如果一笔单据中有部分支付失败，您可以"
  },

  paymentFail: {
    describeTitle:
      "当您确认了前一次支付失败的原因后，您可以纠正该问题，并再次导出支付信息进行付款。",
    describe:
      "当您收到银行对账单，确认已经付款成功时，您可以勾选相应的支付信息，并点击“确认付讫”按钮。"
  }
};

export const paidSucceedHints =
  "确认付讫后系统将认定该单据支付成功，请确认银行对账单确实付款成功！";

export const initPaymentModeCode = "confirmByApply";

export const isPaymentByInvoice = paymentModeCode => {
  return paymentModeCode === initPaymentModeCode;
};

export const getMergeLinesByPaymentMode = paymentModeCode => {
  return isPaymentByInvoice(paymentModeCode) ? mergeLines : [];
};

export const getPaymentSelectedAttr = paymentModeCode => {
  return isPaymentByInvoice(paymentModeCode) ? "applyId" : "id";
};

export const getPaymentSelectedIdsKey = paymentModeCode => {
  const attr = getPaymentSelectedAttr(paymentModeCode);
  return `${attr}s`;
};

export const getPaidFailedHints = paymentModeCode => {
  if (isPaymentByInvoice(paymentModeCode)) {
    return "请确认支付失败的记录，是否整单均支付失败？";
  } else {
    return "标记支付失败的记录，可以在 “支付失败” 列表中重新标记，确定标记吗？";
  }
};

export const getExportPaymentInfoButtonText = paymentStatus => {
  const basicText = "确认并导出支付信息";
  if (paymentStatus === "waitPay") {
    return basicText;
  } else if (paymentStatus === "paymentFail") {
    return `重新${basicText}`;
  }
};

export const getConfirmExportPaymentInfoApi = (paymentStatus, needExport) => {
  if (paymentStatus === "paymentFail") {
    return needExport ? apis.exportPaymentRefresh : apis.exportPaymentRefreshNotExport
  };
  return needExport ? apis.exportPayment : apis.exportPaymentNotExport
};

export const paymentStatusColors = [
  {
    code: "waitPay",
    color: "#2db7f5"
  },
  {
    code: "reconciled",
    color: "#c5c8ce"
  },
  {
    code: "finished",
    color: "#19be6b"
  },
  {
    code: "paymentFail",
    color: "#ed4014"
  }
];
